'use strict';

var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var _require = require('./HttpClient'),
  HttpClient = _require.HttpClient,
  HttpClientResponse = _require.HttpClientResponse;
/**
 * HTTP client which uses a `fetch` function to issue requests.
 *
 * By default relies on the global `fetch` function, but an optional function
 * can be passed in. If passing in a function, it is expected to match the Web
 * Fetch API. As an example, this could be the function provided by the
 * node-fetch package (https://github.com/node-fetch/node-fetch).
 */
var FetchHttpClient = /*#__PURE__*/function (_HttpClient) {
  _inherits(FetchHttpClient, _HttpClient);
  function FetchHttpClient(fetchFn) {
    var _this;
    _classCallCheck(this, FetchHttpClient);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FetchHttpClient).call(this));
    _this._fetchFn = fetchFn;
    return _this;
  }

  /** @override. */
  _createClass(FetchHttpClient, [{
    key: "getClientName",
    value: function getClientName() {
      return 'fetch';
    }
  }, {
    key: "makeRequest",
    value: function makeRequest(host, port, path, method, headers, requestData, protocol, timeout) {
      var isInsecureConnection = protocol === 'http';
      var url = new URL(path, "".concat(isInsecureConnection ? 'http' : 'https', "://").concat(host));
      url.port = port;
      var fetchFn = this._fetchFn || fetch;
      var fetchPromise = fetchFn(url.toString(), {
        method: method,
        headers: headers,
        body: requestData || undefined
      });

      // The Fetch API does not support passing in a timeout natively, so a
      // timeout promise is constructed to race against the fetch and preempt the
      // request, simulating a timeout.
      //
      // This timeout behavior differs from Node:
      // - Fetch uses a single timeout for the entire length of the request.
      // - Node is more fine-grained and resets the timeout after each stage of
      //   the request.
      //
      // As an example, if the timeout is set to 30s and the connection takes 20s
      // to be established followed by 20s for the body, Fetch would timeout but
      // Node would not. The more fine-grained timeout cannot be implemented with
      // fetch.
      var pendingTimeoutId;
      var timeoutPromise = new Promise(function (_, reject) {
        pendingTimeoutId = setTimeout(function () {
          pendingTimeoutId = null;
          reject(HttpClient.makeTimeoutError());
        }, timeout);
      });
      return Promise.race([fetchPromise, timeoutPromise]).then(function (res) {
        return new FetchHttpClientResponse(res);
      }).finally(function () {
        if (pendingTimeoutId) {
          clearTimeout(pendingTimeoutId);
        }
      });
    }
  }]);
  return FetchHttpClient;
}(HttpClient);
var FetchHttpClientResponse = /*#__PURE__*/function (_HttpClientResponse) {
  _inherits(FetchHttpClientResponse, _HttpClientResponse);
  function FetchHttpClientResponse(res) {
    var _this2;
    _classCallCheck(this, FetchHttpClientResponse);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(FetchHttpClientResponse).call(this, res.status, FetchHttpClientResponse._transformHeadersToObject(res.headers)));
    _this2._res = res;
    return _this2;
  }
  _createClass(FetchHttpClientResponse, [{
    key: "getRawResponse",
    value: function getRawResponse() {
      return this._res;
    }
  }, {
    key: "toStream",
    value: function toStream(streamCompleteCallback) {
      // Unfortunately `fetch` does not have event handlers for when the stream is
      // completely read. We therefore invoke the streamCompleteCallback right
      // away. This callback emits a response event with metadata and completes
      // metrics, so it's ok to do this without waiting for the stream to be
      // completely read.
      streamCompleteCallback();

      // Fetch's `body` property is expected to be a readable stream of the body.
      return this._res.body;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this._res.json();
    }
  }], [{
    key: "_transformHeadersToObject",
    value: function _transformHeadersToObject(headers) {
      // Fetch uses a Headers instance so this must be converted to a barebones
      // JS object to meet the HttpClient interface.
      var headersObj = {};
      var _iterator = _createForOfIteratorHelper(headers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          if (!Array.isArray(entry) || entry.length != 2) {
            throw new Error('Response objects produced by the fetch function given to FetchHttpClient do not have an iterable headers map. Response#headers should be an iterable object.');
          }
          headersObj[entry[0]] = entry[1];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return headersObj;
    }
  }]);
  return FetchHttpClientResponse;
}(HttpClientResponse);
module.exports = {
  FetchHttpClient: FetchHttpClient,
  FetchHttpClientResponse: FetchHttpClientResponse
};